module.exports = __webpack_public_path__ + "img/avatar3.af898aec.png";